import { getListItems } from "./getListItems.js";
import { getParentList } from "./getParentList.js";
/**
 * Get all lists in the given Range.
 */
export function getLists(editor, schema, at) {
  const listItemsInRange = getListItems(editor, schema, at);
  const lists = listItemsInRange.map(_ref => {
    let [, listItemPath] = _ref;
    return getParentList(editor, schema, listItemPath);
  }).filter(list => list !== null);
  // TypeScript complains about `null`s even though we filter for them, hence the typecast.
  return lists;
}